<template>
  <FinderResultLayout
    v-bind="props"
    result-type="location"
    :labels="labels"
    :thumbnail="thumbnail"
    v-on="forwardedEvents"
  >
    <template #bio-details="{ hoursBadgeAvailability }">
      <FinderResultHoursBadge v-if="hoursBadgeAvailability" :availability="hoursBadgeAvailability" />
    </template>
  </FinderResultLayout>
</template>

<script setup>
import { computed } from "vue";
import { resultText } from "#ce/components/SpFinder/view-models/result-text";
import { createFinderResultListeners } from "#ce/components/SpFinder/event-listeners/finder-result-listeners";
import { useFinderResultLabels } from "./composables/useFinderResultLabels";
import FinderResultHoursBadge from "./components/FinderResultHoursBadge.ce.vue";
import FinderResultLayout from "./components/FinderResultLayout.ce.vue";
import { props as propsDefinitions } from "./props/finder-result.js";

const props = defineProps(propsDefinitions);

const emit = defineEmits(["add-filters", "show-map", "show-more-slots", "show-date"]);

const forwardedEvents = createFinderResultListeners(emit);

const labels = useFinderResultLabels(
  () => props.labels,
  () => ({
    disclaimer: resultText("location_disclaimer"),
    disclaimerHeading: resultText("location_disclaimer_heading"),
  }),
);

const thumbnail = computed(() => ({
  imageUrl: props.result.image_url,
  physicianImageUrls: props.result.physician_image_urls || [],
  physicianCountLabel: props.result.physician_count ? props.result.physician_count_label : "",
}));
</script>
